import request from '@/utils/request'

export function save(data) {
  return request({
    url: 'person/save',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: 'person/update',
    method: 'put',
    data
  })
}

export function deleteRow(id) {
  return request({
    url: 'person/delete',
    method: 'delete',
    data: id
  })
}

export function getById(id) {
  return request({
    url: 'person/getById/' + id,
    method: 'get'
  })
}

export function search(data, type) {
 return request({
   url: 'person/search/' + data + '/' + type,
   method: 'get'
 })
}
